/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilegrouporganizers2Inputs */

const en_profilegrouporganizers2 = /** @type {(inputs: Profilegrouporganizers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizers`)
};

const de_profilegrouporganizers2 = /** @type {(inputs: Profilegrouporganizers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter`)
};

/**
* | output |
* | --- |
* | "Organizers" |
*
* @param {Profilegrouporganizers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilegrouporganizers2 = /** @type {((inputs?: Profilegrouporganizers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilegrouporganizers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilegrouporganizers2(inputs)
	return de_profilegrouporganizers2(inputs)
});
export { profilegrouporganizers2 as "profileGroupOrganizers" }